import type { JsonBody, SuccessResponse } from './openapi-helpers';
import type { paths } from './openapi-schema';
import { extractErrorMessage, readResponseBody, resolveUrl } from './http';

const CREATE_PUBLIC_AUDIT_REQUEST_OPERATION = {
  method: 'post',
  path: '/api/v1/public/audit-requests',
} as const;

type CreatePublicAuditRequestOperation =
  paths['/api/v1/public/audit-requests']['post'];

export type PublicAuditRequestPayload = JsonBody<
  NonNullable<CreatePublicAuditRequestOperation['requestBody']>
>;
export type PublicAuditRequestResponse = SuccessResponse<
  Pick<CreatePublicAuditRequestOperation['responses'], 202>
>;

export class PublicMarketingRequestError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = 'PublicMarketingRequestError';
    this.status = status;
  }
}

export async function createPublicAuditRequest(
  payload: PublicAuditRequestPayload
): Promise<PublicAuditRequestResponse> {
  let response: Response;

  try {
    response = await fetch(resolveUrl(CREATE_PUBLIC_AUDIT_REQUEST_OPERATION.path), {
      method: CREATE_PUBLIC_AUDIT_REQUEST_OPERATION.method.toUpperCase(),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
  } catch (error) {
    throw new PublicMarketingRequestError(
      'Não foi possível enviar o pedido de auditoria agora.',
      0
    );
  }

  const responseBody = await readResponseBody(response);

  if (!response.ok) {
    throw new PublicMarketingRequestError(
      extractErrorMessage(
        responseBody,
        `Não foi possível enviar o pedido de auditoria agora. (${response.status})`
      ),
      response.status
    );
  }

  if (
    responseBody &&
    typeof responseBody === 'object' &&
    'success' in responseBody &&
    typeof responseBody.success === 'boolean'
  ) {
    return responseBody as PublicAuditRequestResponse;
  }

  return { success: true };
}
